import { Avatar as PaperAvatar } from "react-native-paper";

interface AvatarProps {
    name: string
    src?: string,
    size?: number
}

export function Avatar({ src, name, size = 80 }: AvatarProps) {
    if (src) {
        return (<PaperAvatar.Image source={{ uri: src }} size={size} />)

    }
    const initials = abbreviateName(name);
    return (<PaperAvatar.Text label={initials} size={size} />)
}

const abbreviateName = (fullName: string) => {
    // 1. Trim whitespace and split the name into an array of words
    const words = fullName.trim().split(' ');

    const initials = words.map(word => word.charAt(0).toUpperCase());

    // 3. Join the initials into a single string
    return initials.join('');
};